import { render, staticRenderFns } from "./AochenContent.vue?vue&type=template&id=16683b32&scoped=true"
import script from "./AochenContent.vue?vue&type=script&lang=js"
export * from "./AochenContent.vue?vue&type=script&lang=js"
import style0 from "./AochenContent.vue?vue&type=style&index=0&id=16683b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16683b32",
  null
  
)

export default component.exports